const avatarMenu = [
  {
    label: 'Your courses',
    route: '/courses/'
  },
  {
    label: 'Profile',
    route: '/profile/'
  }
]

export default avatarMenu
